import * as React from 'react';
import { cn } from '@/lib/utils';

const ChallengeActivities = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-challenge-activities', 'shadow-dropwhadow-sm flex flex-col rounded-xl border border-solid border-neutral-lightest bg-white p-5', className)}
    {...props}
  />
));
ChallengeActivities.displayName = 'ChallengeActivities';

const ChallengeActivitiesHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-challenge-activities-header', 'mb-3', className)}
    {...props}
  />
));
ChallengeActivitiesHeader.displayName = 'ChallengeActivitiesHeader';

const ChallengeActivitiesTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-challenge-activities-title', 'mb-0 text-base font-bold text-primary-dark', className)}
    {...props}
  />
));
ChallengeActivitiesTitle.displayName = 'ChallengeActivitiesTitle';

const ChallengeActivitiesBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-challenge-activities-body', 'flex flex-col gap-3', className)}
    {...props}
  />
));
ChallengeActivitiesBody.displayName = 'ChallengeActivitiesBody';

const variantStyles = {
  default: {
    '--color-primary-dark': ' #313fa9',
    '--color-primary': '#4551AD',
    '--color-primary-light': '#A1DFFD',
    '--color-primary-lighter': '#DDF4FF'
  },
  turbo: {
    '--color-primary-dark': '#df274c',
    '--color-primary': '#FF4C6F',
    '--color-primary-light': '#FDE5EA',
    '--color-primary-lighter': '#FFF6F8'
  },
  conquest: {
    '--color-primary-dark': '#ef9526',
    '--color-primary': '#F9AD53',
    '--color-primary-light': '#FDB462',
    '--color-primary-lighter': '#FFF5E9'
  }
};

const ChallengeActivitiesCard = React.forwardRef(({ variant = 'default', className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-challenge-activities-card', 'mb-0 flex items-start gap-2 text-xs font-light text-neutral-dark', className)}
    style={variantStyles[variant]}
    {...props}
  />
));
ChallengeActivitiesCard.displayName = 'ChallengeActivitiesCard';

const ChallengeActivitiesCardIcon = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-lighter text-primary', className)}
    {...props}
  >
    {React.Children.map(props.children, child =>
      React.cloneElement(child, {
        className: cn('w-[14px] h-auto stroke-color-primary', child.props.className)
      })
    )}
  </span>
));
ChallengeActivitiesCardIcon.displayName = 'ChallengeActivitiesCardIcon';

const ChallengeActivitiesCardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('w-5 flex-grow break-words leading-none', className)}
    {...props}
  />
));
ChallengeActivitiesCardContent.displayName = 'ChallengeActivitiesCardContent';

const ChallengeActivitiesCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('block w-full max-w-full truncate text-[14px] font-bold leading-tight text-neutral-dark', className)}
    {...props}
  />
));
ChallengeActivitiesCardTitle.displayName = 'ChallengeActivitiesCardTitle';

const ChallengeActivitiesCardName = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('block w-full max-w-full truncate text-[12px] font-light text-neutral-dark', className)}
    {...props}
  />
));
ChallengeActivitiesCardName.displayName = 'ChallengeActivitiesCardName';

const ChallengeActivitiesCardValue = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('shrink-0 font-bold', className)}
    {...props}
  />
));
ChallengeActivitiesCardValue.displayName = 'ChallengeActivitiesCardValue';

export {
  ChallengeActivities,
  ChallengeActivitiesHeader,
  ChallengeActivitiesTitle,
  ChallengeActivitiesBody,
  ChallengeActivitiesCard,
  ChallengeActivitiesCardIcon,
  ChallengeActivitiesCardContent,
  ChallengeActivitiesCardTitle,
  ChallengeActivitiesCardName,
  ChallengeActivitiesCardValue
};
